import React from 'react'

import { ThemeProvider } from '@mui/material'

import { theme as defaultTheme } from '@/lib/theme'
import { theme as oldTheme } from '~/muiTheme'
import { theme as payrollsTheme } from '~/pages/payrolls/payrollsTheme'

const themeMap = {
  default: defaultTheme,
  old: oldTheme, // TODO: Rename it to 'legacy' instead of 'old'
  payrolls: payrollsTheme,
} as const

type Theme = keyof typeof themeMap

export function withTheme<P>(Component: React.ComponentType<P>, themeName: Theme = 'default') {
  // Still forwardRef: Component is ComponentType<P>, which has no ref prop to spread into.
  return React.forwardRef<unknown, P & { theme?: Theme }>(function ThemedComponent(props, ref) {
    const theme = (props.theme && themeMap[props.theme]) ?? themeMap[themeName]
    return (
      <ThemeProvider theme={theme}>
        <Component ref={ref} {...(props as P)} />
      </ThemeProvider>
    )
  })
}
